class ProtectionSet {

    constructor() {
        this._filterKey = 'name';
        this.name = '';
        this.uuid = '';
        this.resourceGroups = [];
    }

    static fromRaw(raw) {
        let protectionSet = new ProtectionSet();
        protectionSet.uuid = raw.uuid;
        protectionSet.name = raw.name;
        protectionSet.resourceGroups = raw.resourceGroups;
        return protectionSet;
    }

    toRaw() {
        return {
            // uuid: this.uuid,
            name: this.name,
            resourceGroups: this.resourceGroups
        }
    }
}

module.exports = ProtectionSet;


// WEBPACK FOOTER //
// ./src/azurebackup/model/ProtectionSet.js